import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useQuery } from 'react-query'
import { getMessage } from 'src/services/MessageService'
import MessageView from './MessageView'

type Props = {
  messageId: string
}

function Message({ messageId }: Props): JSX.Element {
  const [title, setTitle] = useState('')

  const messageQuery = useQuery(['messageDetail', messageId], () => getMessage(messageId))

  const { data, isSuccess } = messageQuery

  useEffect(() => {
    if (isSuccess) {
      setTitle(data ? data?.results.datos.asunto : '')
    }
  }, [data, isSuccess])

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <MessageView messageQuery={messageQuery} />
    </>
  )
}

export default Message
